import { render, staticRenderFns } from "./collectormonitor.vue?vue&type=template&id=3bff6168&"
import script from "./collectormonitor.vue?vue&type=script&lang=ts&"
export * from "./collectormonitor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collectormonitor.vue"
export default component.exports